export const TABLE_SKELETON_ROWS_SIZE = 10;

export const TABLE_PAGE_LIMIT = 100;
